import React, { useState, useEffect, useContext, createContext } from "react";
import axios from "axios";
const CountryContext = createContext();

const CountryProvider = ({ children }) => {
  const data = sessionStorage.getItem("country_data");
  console.log(data);
  const parseData = JSON.parse(data);
  const [country, setCountry] = useState({
    country_code: parseData ? parseData.country_code : "",
    calling_code: parseData ? parseData.country_calling_code : "",
    code: parseData ? parseData.currency : "",
    currency_name: parseData ? parseData.currency_name : "",
    country_name: parseData ? parseData.country_name : "",
    status: parseData ? parseData.status : false,
  });

  /*
    useEffect(()=>{
            const data = localStorage.getItem('country_data')
            const parseData = JSON.parse(data);
            if(parseData?.status){
                setCountry({
                    ...country,
                    country_code: parseData.country_code,
                    calling_code: parseData.country_calling_code,
                    code: parseData.currency,
                    currency_name: parseData.currency_name,
                    country_name:parseData.country_name,
                })
            }
    },[])*/

  return (
    <CountryContext.Provider value={[country, setCountry]}>
      {children}
    </CountryContext.Provider>
  );
};

//custom hook
const useCountry = () => useContext(CountryContext);

export { useCountry, CountryProvider };
